import React from "react";
import CommonTable, { HeadCell } from "src/business-types/grocery/components/CommonTable";

interface Product {
  id: number | string;
  name: string;
  unitPrice: number | string;
  quantity: number;
  lineTotal: number | string;
}

interface Props {
  products: Omit<Product, "id">[]; // input can omit id — we’ll generate it
}

const OrderProductsList: React.FC<Props> = ({ products }) => {
  const headCells: HeadCell<Product>[] = [
    { id: "id", label: "S.No" },
    { id: "name", label: "Product name" },
    { id: "unitPrice", label: "Price (QAR)", align: "right" },
    { id: "quantity", label: "Total quantity", align: "center" },
    { id: "lineTotal", label: "Total (QAR)" , align: "right", },
  ];

  const tableData: Product[] = (products || []).map((p, index) => ({
    id: index + 1,
    name: p.name,
    unitPrice: Number(p.unitPrice).toFixed(2),
    quantity: p.quantity,
    lineTotal: Number(p.lineTotal).toFixed(2),
  }));

  return (
  <div className="flex-1 min-h-0 overflow-y-auto">
    <CommonTable<Product>
      data={tableData}
      headCells={headCells}
      title="Ordered Products"
      selectable={false}
      denseToggle={false}
      pageSize={10}
      pagenation={true}
      showToolbar={false}
      className="w-full h-full shadow-inner rounded-lg bg-white p-2 overflow-auto"
    />
  </div>

  );
};

export default OrderProductsList;
